<template>
  <el-row :gutter="20">
    <el-col :span="10"><div class="grid-content bg-purple mast-center">  <img v-if="mast" :src="mast" > </div></el-col>
    <el-col :span="14"><div class="grid-content bg-purple">
<!--      <div>信息中心</div>-->
      <el-table
        :data="tableData"
        :show-header="false">
        <el-table-column
          prop="updateTime"
          :formatter="dateFormat"
          width="100">
        </el-table-column>
        <el-table-column
          prop="title"
          :show-overflow-tooltip='true'>
          <template slot-scope="scope">
          <router-link  class="new-row" v-bind:to="'/news/'+scope.row.id">{{scope.row.title}}</router-link>
          </template>
        </el-table-column>
      </el-table>
    </div></el-col>
  </el-row>

</template>

<script>
import Mast from '@/assets/mast.png'
export default {
  name: 'Info',
  data () {
    return {
      mast: Mast,
      tableData: []
    }
  },
  created () {
    const self = this
    this.$axios.get('/cms/getcolumn/1')
      .then(function (res) {
        self.tableData = res.data.data
        console.log(res)
      })
      .catch(res => {
        console.log(res)
      })
  },
  methods: {
    // eslint-disable-next-line no-undef
    dateFormat: function (row, column) {
      var date = row[column.property]
      if (date === undefined) {
        return ''
      }
      // eslint-disable-next-line no-undef
      return this.$moment(date).format('YYYY-MM-DD')
    }
  }
}
</script>

<style scoped>
  .grid-content {
    border-radius: 10px !important;
    font-size: 1.8em;
    line-height: 2em;
  }
  .bg-purple {

  }

  p{text-indent:2em;}
  .mast-center
  {
    text-align: right;
  }
  .mast-center img{
max-width: 400px;
  }
  .new-row{
    font-size: 1.4em !important;
    text-decoration:none;
    color: black;
  }
</style>
